import { ReactNode } from 'react';

type FontFamily =
    | `'Inter', sans-serif`
    | `'Poppins', sans-serif`
    | `'Roboto', sans-serif`
    | `'Public Sans', sans-serif`;
type PresetColor = 'default' | 'theme1' | 'theme2' | 'theme3' | 'theme4' | 'theme5' | 'theme6' | 'theme7' | 'theme8';
type I18n = 'en' | 'fr' | 'ro' | 'zh';

type FirstBuilderStart = true | false;

enum ThemeMode {
    LIGHT = 'light',
    DARK = 'dark',
}

enum MenuOrientation {
    VERTICAL = 'vertical',
    HORIZONTAL = 'horizontal',
}

enum ThemeDirection {
    LTR = 'ltr',
    RTL = 'rtl',
}

type CustomizationActionProps = {
    type: string;
    payload?: CustomizationProps;
};

type DefaultConfigProps = {
    fontFamily: FontFamily;
    i18n: I18n;
    menuOrientation: MenuOrientation;
    miniDrawer: boolean;
    container: boolean;
    showBuilderGuide: boolean;
    mode: ThemeMode;
    presetColor: PresetColor;
    themeDirection: ThemeDirection;
    firstBuilderStart: FirstBuilderStart;
    builderProject: string | null;
};

type ConfigProviderProps = {
    children: ReactNode;
};

type TabType = 'Details' | 'Progress';

type CustomizationProps = {
    fontFamily: FontFamily;
    i18n: I18n;
    miniDrawer: boolean;
    showBuilderGuide: boolean;
    container: boolean;
    menuOrientation: MenuOrientation;
    mode: ThemeMode;
    presetColor: PresetColor;
    themeDirection: ThemeDirection;
    firstBuilderStart: FirstBuilderStart;
    builderProject: string | null;
    onChangeContainer: VoidFunction;
    onChangeLocalization: (lang: I18n) => void;
    onChangeMode: (mode: ThemeMode) => void;
    onChangePresetColor: (theme: PresetColor) => void;
    onChangeDirection: (direction: ThemeDirection) => void;
    onChangeMiniDrawer: (miniDrawer: boolean) => void;
    onChangeMenuOrientation: (menuOrientation: MenuOrientation) => void;
    onChangeFontFamily: (fontFamily: FontFamily) => void;
    onChangeshowBuilderGuide: (showBuilderGuide: boolean) => void;
    onChangeFirstBuilderStart: (firstBuilderStart: FirstBuilderStart) => void;
};

export type {
    CustomizationProps,
    CustomizationActionProps,
    DefaultConfigProps,
    ConfigProviderProps,
    I18n,
    FontFamily,
    PresetColor,
    FirstBuilderStart,
    TabType,
};

export { ThemeDirection, ThemeMode, MenuOrientation };
